export default __webpack_public_path__ + "static/media/website-header-modified.0d2c5dc6.jpg";